import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2, XCircle, Info, X } from "lucide-react";

const CONFIG = {
  success: { background: "#16a34a", Icon: CheckCircle2 },
  error:   { background: "#dc2626", Icon: XCircle },
  info:    { background: "#2563eb", Icon: Info },
};

function ToastItem({ toast, onDismiss }) {
  const { background, Icon } = CONFIG[toast.type] || CONFIG.info;

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: -20, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -12, scale: 0.96 }}
      transition={{ type: "spring", stiffness: 380, damping: 28 }}
      onClick={() => onDismiss(toast.id)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        background,
        color: "#fff",
        borderRadius: "12px",
        padding: "14px 16px",
        width: "min(420px, calc(100vw - 32px))",
        boxShadow: "0 4px 20px rgba(0,0,0,0.30)",
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: 1.4,
        cursor: "pointer",
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <Icon size={22} style={{ flexShrink: 0 }} />
      <span style={{ flex: 1 }}>{toast.message}</span>
      {toast.action && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); toast.action.onClick(); onDismiss(toast.id); }}
          style={{
            flexShrink: 0,
            background: "rgba(255,255,255,0.2)",
            border: "none",
            borderRadius: "8px",
            color: "#fff",
            fontSize: "0.8rem",
            fontWeight: 700,
            padding: "3px 8px",
            cursor: "pointer",
          }}
        >
          {toast.action.label}
        </button>
      )}
      <X size={18} style={{ flexShrink: 0, opacity: 0.8 }} />
    </motion.div>
  );
}

export default function ToastContainer({ toasts, onDismiss }) {
  return (
    <div
      style={{
        position: "fixed",
        top: "16px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
        pointerEvents: "none",
      }}
    >
      <AnimatePresence>
        {toasts.map((toast) => (
          <div key={toast.id} style={{ pointerEvents: "auto" }}>
            <ToastItem toast={toast} onDismiss={onDismiss} />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
}
